export interface IVendor {
  vendorId: string;
  vendorName: string;
  isActive: boolean;
}
